import React, { useState, useEffect } from "react";

import { useTranslation } from "react-i18next";
import GemstoneReportsShapeComp from "../../ChartsGroup/GemstoneReportsCharts/GemstoneReportsShapeComp";
import GemstoneReportsClarityComp from "../../ChartsGroup/GemstoneReportsCharts/GemstoneReportsClarityComp";
import GemstoneReportsCertificateComp from "../../ChartsGroup/GemstoneReportsCharts/GemstoneReportsCertificateComp";
import moment from "moment";
import { useSelector } from "react-redux";
import AdminGemstoneReportService from "../../../services/reports-AdminGemstone-service";
import GemstoneReportsGemTypeComp from "../../ChartsGroup/GemstoneReportsCharts/GemstoneReportsGemTypeComp";
import GemstoneReportsColorComp from "../../ChartsGroup/GemstoneReportsCharts/GemstoneReportsColorComp";
import GemstoneReportsSizeComp from "../../ChartsGroup/GemstoneReportsCharts/GemstoneReportsSizeComp";
import GemstoneReportsPriceComp from "../../ChartsGroup/GemstoneReportsCharts/GemstoneReportsPriceComp";
import ReportKpiBand from "../../ChartsGroup/GemstoneReportsCharts/ReportKpiBand";
import ReportInsight from "../../ChartsGroup/GemstoneReportsCharts/ReportInsight";
import ReportTabs from "../../ChartsGroup/GemstoneReportsCharts/ReportTabs";
import GlobalGemstoneReportService from "../../../services/reports-globalGemstone-service";
import { DatePicker, Select, message } from "antd";
import { BlobToDownloadFile } from "../../../helper/commanFunction";
import GemstoneReportsClicksComp from "../../ChartsGroup/GemstoneReportsCharts/GemstoneReportsClicksComp";
const { RangePicker } = DatePicker;
const { Option } = Select;

const ExtendedGemstoneChartReports = () => {
  const { t } = useTranslation();
  useEffect(() => {
    if (loginDetials) {
      if (loginDetials.loginDetials) {
        if (loginDetials.loginDetials.responseData.logInSucceeded) {
          setDealerId(loginDetials.loginDetials.responseData.dealerId);
          handleCheckDealermembers(
            loginDetials.loginDetials.responseData.dealerId
          );
        }
      }
    }
    handleGetVendorDropdownData();
    handleGetRetailerDropdownData();
  }, []);

  const initialGlobalGemstoneState = {
    dataRangeFrom: moment().subtract(30, "days").format("YYYY-MM-DD"),
    dataRangeTo: moment().format("YYYY-MM-DD"),
    SelectedGemstoneValue: "All",
    retailerIds: [],
    vendorIds: [],
  };
  const [dealerId, setDealerId] = useState();
  const loginDetials = useSelector((state) => state.loginReducer);
  const [forDealer, setForDealer] = useState("");
  const [LoadChartReportsLoading, setLoadChartReportsLoading] = useState(false);
  const [checkingMembership, setCheckingMembership] = useState(true);
  const [report, setReport] = useState(null);
  const [loadError, setLoadError] = useState(false);
  const [globalGemstones, setGlobalGemstone] = useState(
    initialGlobalGemstoneState
  );
  const [isApplyFilter, setIsApplyFilter] = useState(false);
  const [vendorList, setVendorList] = useState([]);
  const [retailerList, setRetailerList] = useState([]);
  const [downloadingPdf, setDownloadingPdf] = useState(false);
  const [chartViews, setChartViews] = useState({});
  const [noiseFilters, setNoiseFilters] = useState({ Shape: true });

  const onDateChange = (dates, dateStrings) => {
    if (dates) {
      setGlobalGemstone((prevState) => ({
        ...prevState,
        dataRangeFrom: dateStrings[0],
        dataRangeTo: dateStrings[1],
      }));
    }
  };

  const handleCheckDealermembers = (id) => {
    let inputData = {
      dealerID: id,
    };
    AdminGemstoneReportService.CheckDealermembers(inputData)
      .then((response) => {
        var message = response.data.message;
        var responseData = response.data.responseData;
        var forDealer = responseData.forDealer;
        if (message === "Success") {
          if (Object.keys(responseData).length !== 0) {
            setForDealer(forDealer);
          } else {
            setForDealer("");
          }
          setCheckingMembership(false);
          handleLoadChartReports(id, forDealer);
        } else {
          setForDealer("");
          setCheckingMembership(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setForDealer("");
        setCheckingMembership(false);
      });
  };

  const handleLoadChartReports = (dealerId, forDealer) => {
    let inputData = {
      dealerID: dealerId.toString(),
      forDealer: forDealer ? forDealer.toString() : "",
      fromDate: globalGemstones.dataRangeFrom
        ? moment(globalGemstones.dataRangeFrom).format("YYYY-MM-DD")
        : "2020-08-17",
      toDate: globalGemstones.dataRangeTo
        ? moment(globalGemstones.dataRangeTo).format("YYYY-MM-DD")
        : "2022-09-15",
      retailerIds: globalGemstones.retailerIds.toString(),
      vendorIds: globalGemstones.vendorIds.toString(),
      selectedGemstoneValue: globalGemstones.SelectedGemstoneValue,
      type: "Global",
      reportName: "ExtendedGemstoneCharts",
    };
    setLoadChartReportsLoading(true);
    setLoadError(false);

    AdminGemstoneReportService.LoadChartReports(inputData)
      .then((response) => {
        var message = response.data.message;
        var responseData = response.data.responseData;
        if (message === "Success" && Object.keys(responseData).length !== 0) {
          setReport(responseData);
        } else {
          setReport(null);
          setLoadError(true);
        }
      })
      .catch((error) => {
        setReport(null);
        setLoadError(true);
      })
      .finally(() => setLoadChartReportsLoading(false));
  };

  const handleOnChange = (e, isSelect, name) => {
    let vId = "";
    let rId = "";
    if (isSelect === "select" && name === "vendors") {
      vId = e.includes(0) ? [0] : e;
      setGlobalGemstone((prevState) => {
        const updatedState = { ...prevState, vendorIds: vId };
        if (
          updatedState.vendorIds.length === 0 &&
          updatedState.retailerIds?.length === 0
        ) {
          handleGetVendorDropdownData();
          handleGetRetailerDropdownData();
        } else {
          changeRetailerListHandler(vId);
        }

        return updatedState;
      });
    } else if (isSelect === "select" && name === "retailers") {
      rId = e.includes(0) ? [0] : e;
      setGlobalGemstone((prevState) => {
        const updatedState = { ...prevState, retailerIds: rId };
        if (
          updatedState.vendorIds?.length === 0 &&
          updatedState.retailerIds.length === 0
        ) {
          handleGetVendorDropdownData();
          handleGetRetailerDropdownData();
        } else {
          changeVendorListHandler(rId);
        }

        return updatedState;
      });
    } else {
      setGlobalGemstone((prevState) => ({
        ...prevState,
        [name]: e,
      }));
    }
  };

  const handleGetVendorDropdownData = () => {
    GlobalGemstoneReportService.GetVendors()
      .then((response) => {
        var message = response.data.message;
        var responseData = response.data.responseData;
        if (message === "Success") {
          if (Object.keys(responseData).length !== 0) {
            setVendorList(responseData.Table);
          }
        } else {
          setVendorList([]);
        }
      })
      .catch((error) => {
        setVendorList([]);
      });
  };

  const handleGetRetailerDropdownData = () => {
    GlobalGemstoneReportService.GetRetailers()
      .then((response) => {
        var message = response.data.message;
        var responseData = response.data.responseData;
        if (message === "Success") {
          if (Object.keys(responseData).length !== 0) {
            setRetailerList(responseData.Table);
          }
        }
      })
      .catch((error) => {
        console.log(error);
        setRetailerList([]);
      });
  };

  const changeRetailerListHandler = (data) => {
    data = data.toString();
    let inputData = {
      vendorsID: data,
    };
    GlobalGemstoneReportService.GetRetailersOnVendorDropdownChange(inputData)
      .then((response) => {
        var message = response.data.message;
        var responseData = response.data.responseData;
        if (message === "Success") {
          if (Object.keys(responseData).length !== 0) {
            setRetailerList(responseData.retailers);
          }
        }
      })
      .catch((error) => {
        console.log(error);
        setRetailerList([]);
      });
  };
  const changeVendorListHandler = (data) => {
    data = data.toString();
    let inputData = {
      retailerID: data,
    };
    GlobalGemstoneReportService.GetVendorsOnRetailerDropdownChange(inputData)
      .then((response) => {
        var message = response.data.message;
        var responseData = response.data.responseData;
        if (message === "Success") {
          if (Object.keys(responseData).length !== 0) {
            if (responseData.vendors !== null) {
              setVendorList(responseData.vendors);
            }
          }
        } else {
          setVendorList([]);
        }
      })
      .catch((error) => {
        console.log(error);
        setVendorList([]);
      });
  };

  const handleApplyFilter = () => {
    handleCheckDealermembers(dealerId);
    setIsApplyFilter(!isApplyFilter);
  };

  // Download PDF - reuses GlobalGemstoneReportService.ExportActivityPdf, the
  // same way admin ExtendedDiamondChartReports.js reuses the Global Diamond
  // export (this page's own data is the same type: "Global" query).
  const handleDownloadPdf = () => {
    let inputData = {
      dealerID: dealerId ? dealerId.toString() : "",
      forDealer: forDealer ? forDealer.toString() : "",
      fromDate: globalGemstones.dataRangeFrom
        ? moment(globalGemstones.dataRangeFrom).format("YYYY-MM-DD")
        : "2020-08-17",
      toDate: globalGemstones.dataRangeTo
        ? moment(globalGemstones.dataRangeTo).format("YYYY-MM-DD")
        : "2022-09-15",
      retailerIds: globalGemstones.retailerIds.toString(),
      vendorIds: globalGemstones.vendorIds.toString(),
      selectedGemstoneValue: globalGemstones.SelectedGemstoneValue,
      barViewDimensions: Object.keys(chartViews)
        .filter((dim) => chartViews[dim] === "bar")
        .join(","),
      hideShapeNoise: noiseFilters.Shape,
    };
    setDownloadingPdf(true);
    GlobalGemstoneReportService.ExportActivityPdf(inputData)
      .then((response) => {
        setDownloadingPdf(false);
        const filename = `Gemstone_Activity_Admin_${globalGemstones.dataRangeFrom}_${globalGemstones.dataRangeTo}.pdf`;
        BlobToDownloadFile(response.data, filename, "pdf");
      })
      .catch(() => {
        setDownloadingPdf(false);
        message.error(t("Failed to generate PDF. Please try again."));
      });
  };


  return (
    <React.Fragment>
      <div className="pendjewelreq__section form__fields">
        <div className="row magento__mapping">
          <div className="col-md-12">
            <div className="edr-pagehead-row">
              <div className="edr-pagehead">
                <h1 className="edr-pagehead-title">
                  {t("Extended Gemstone Chart Reports")}
                </h1>
                <div className="edr-pagehead-sub">
                  {t("Search & engagement analytics")} ·{" "}
                  {moment(globalGemstones.dataRangeFrom).format("MMM D, YYYY")}{" "}
                  – {moment(globalGemstones.dataRangeTo).format("MMM D, YYYY")}
                </div>
              </div>
              <div className="edr-pagehead-actions">
                <button
                  className="primary-btn"
                  onClick={handleDownloadPdf}
                  disabled={downloadingPdf || !report}
                >
                  {downloadingPdf ? t("Downloading...") : t("Download PDF")}
                </button>
                <button className="primary-btn" onClick={handleApplyFilter}>
                  {t("Apply Filter")}
                </button>
              </div>
            </div>
          </div>

          <div className="col-md-12">
            <div className="row edr-filters">
              <div className="col-md-3">
                <div className="input__block dataRange-input-block datepicker__block">
                  <label> {t("Date Range")} </label>
                  <RangePicker
                    className="date-range-input"
                    ranges={{
                      Today: [moment(), moment()],
                      Yesterday: [
                        moment().subtract(1, "days"),
                        moment().subtract(1, "days"),
                      ],
                      "Last 7 Days": [moment().subtract(7, "days"), moment()],
                      "Last 30 Days": [moment().subtract(30, "days"), moment()],
                      "This Month": [
                        moment().startOf("month"),
                        moment().endOf("month"),
                      ],
                      "Last Month": [
                        moment().subtract(1, "month").startOf("month"),
                        moment().subtract(1, "months").endOf("month"),
                      ],
                      "Last 90 Days": [moment().subtract(90, "days"), moment()],
                      "Year To Date": [moment().startOf("year"), moment()],
                    }}
                    format={"MM-DD-YYYY"}
                    onChange={onDateChange}
                    defaultValue={[moment().subtract(30, "days"), moment()]}
                    defaultPickerValue={[moment().subtract(30, "days"), moment()]}
                  />
                </div>
              </div>
              <div className="col-md-3">
                <div className="input__block">
                  <label> {t("Select Gemstone")} </label>
                  <Select
                    className="border__grey"
                    placeholder={t("All")}
                    showSearch
                    name="SelectedGemstoneValue"
                    optionFilterProp="children"
                    value={
                      globalGemstones.SelectedGemstoneValue
                        ? globalGemstones.SelectedGemstoneValue
                        : null
                    }
                    onChange={(e) =>
                      handleOnChange(e, "select", "SelectedGemstoneValue")
                    }
                  >
                    <Option value="All"> {t("All")} </Option>
                    <Option value="Mined"> {t("Mined Gemstone")} </Option>
                  </Select>
                </div>
              </div>

              <div className="col-md-3">
                <div className="input__block">
                  <label> {t("Vendor(s)")} </label>
                  <Select
                    className="border__grey"
                    showSearch
                    mode="multiple"
                    showArrow
                    placeholder={t("Select one or more vendor")}
                    optionFilterProp="children"
                    value={globalGemstones.vendorIds}
                    onChange={(e) => handleOnChange(e, "select", "vendors")}
                  >
                    {vendorList.length > 0 &&
                      vendorList.map((item, key) => {
                        return (
                          <Option key={item.dealerID} value={item.dealerID}>
                            {" "}
                            {item.dealercompany}{" "}
                          </Option>
                        );
                      })}
                  </Select>
                </div>
              </div>

              <div className="col-md-3">
                <div className="input__block">
                  <label> {t("Retailer(s)")} </label>
                  <Select
                    showSearch
                    showArrow
                    className="border__grey"
                    placeholder={t("Select one or more retailer ")}
                    optionFilterProp="children"
                    onChange={(e) => handleOnChange(e, "select", "retailers")}
                    notFoundContent={t("No Data Found")}
                    mode="multiple"
                    value={globalGemstones.retailerIds}
                  >
                    {retailerList.length > 0 &&
                      retailerList.map((item, key) => {
                        return (
                          <React.Fragment>
                            <Option key={item.dealerID} value={item.dealerID}>
                              {" "}
                              {item.dealercompany}{" "}
                            </Option>
                          </React.Fragment>
                        );
                      })}
                  </Select>
                </div>
              </div>
            </div>
          </div>

          {forDealer && loadError && (
            <div className="col-md-12">
              <div className="no-report-render">
                <div className="desc-space">
                  <h4 className="text-center">
                    {t("Couldn't load the report. Please try again.")}
                  </h4>
                </div>
              </div>
            </div>
          )}

          {(forDealer || checkingMembership) && !loadError && (
            <div className="col-md-12">
              <ReportKpiBand
                report={report}
                loading={checkingMembership || LoadChartReportsLoading}
                dataRangeFrom={globalGemstones.dataRangeFrom}
                dataRangeTo={globalGemstones.dataRangeTo}
              />
              <ReportInsight report={report} />
            </div>
          )}

          {(forDealer || checkingMembership) && !loadError && (
            <div className="col-md-12">
              <ReportTabs
                overview={
                  <>
                    <div className="col-lg-6">
                      <GemstoneReportsShapeComp
                        data={report?.GemstoneShapeSearches}
                        loading={checkingMembership || LoadChartReportsLoading}
                        onHideNoiseChange={(v) => setNoiseFilters((prev) => ({ ...prev, Shape: v }))}
                      />
                    </div>
                    <div className="col-lg-6">
                      <GemstoneReportsColorComp
                        data={report?.GemstoneColorSearches}
                        loading={checkingMembership || LoadChartReportsLoading}
                        onChartTypeChange={(v) => setChartViews((prev) => ({ ...prev, Color: v === "bar" ? "bar" : "donut" }))}
                      />
                    </div>
                  </>
                }
                attributes={
                  <>
                    <div className="col-lg-12">
                      <GemstoneReportsCertificateComp
                        data={report?.GemstoneCertificateSearches}
                        loading={checkingMembership || LoadChartReportsLoading}
                        onChartTypeChange={(v) => setChartViews((prev) => ({ ...prev, Certificate: v === "bar" ? "bar" : "donut" }))}
                      />
                    </div>
                    <div className="col-lg-12">
                      <GemstoneReportsClarityComp
                        data={report?.GemstoneClaritySearches}
                        loading={checkingMembership || LoadChartReportsLoading}
                        onChartTypeChange={(v) => setChartViews((prev) => ({ ...prev, Clarity: v === "bar" ? "bar" : "donut" }))}
                      />
                    </div>
                    <div className="col-lg-12">
                      <GemstoneReportsGemTypeComp
                        data={report?.GemstoneGemTypeSearches}
                        loading={checkingMembership || LoadChartReportsLoading}
                        onChartTypeChange={(v) => setChartViews((prev) => ({ ...prev, GemType: v === "bar" ? "bar" : "donut" }))}
                      />
                    </div>
                  </>
                }
                commercial={
                  <>
                    <div className="col-lg-6">
                      <GemstoneReportsPriceComp
                        data={report?.GemstonePrice}
                        loading={checkingMembership || LoadChartReportsLoading}
                        onChartTypeChange={(v) => setChartViews((prev) => ({ ...prev, Price: v === "bar" ? "bar" : "donut" }))}
                      />
                    </div>
                    <div className="col-lg-6">
                      <GemstoneReportsSizeComp
                        data={report?.GemstoneSizeSearches}
                        loading={checkingMembership || LoadChartReportsLoading}
                        onChartTypeChange={(v) => setChartViews((prev) => ({ ...prev, Size: v === "bar" ? "bar" : "donut" }))}
                      />
                    </div>
                  </>
                }
                trend={
                  <div className="col-lg-12">
                    <GemstoneReportsClicksComp
                      data={report?.GemstoneClicks}
                      loading={checkingMembership || LoadChartReportsLoading}
                      onChartTypeChange={(v) => setChartViews((prev) => ({ ...prev, Clicks: v === "bar" ? "bar" : "line" }))}
                    />
                  </div>
                }
              />
            </div>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default ExtendedGemstoneChartReports;
